import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
// import dummymarksheet from '../../assets/applause/dummymarksheet.png';
// import tatanexoncar from '../../assets/applause/tatanexoncar.png';
// import iphone15pro from '../../assets/applause/iphone15pro.png';
// import tanishq10gm from '../../assets/applause/tanishq10gm.png';
// import delinspiron from '../../assets/applause/delinspiron.png';
// import voucher2000 from '../../assets/applause/voucher2000.png';
import './sparkle.css';

const MyApplauseGameRules = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    document.title = isLoggedIn ? `${authState.user.name}'s dashboard` : "Think5Whys";
  }, [authState]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000); 

    return () => clearInterval(interval); 
  }, []);

  return (
      <div className='bg-black [&_p]:text-white [&_h2]:text-yellow-200'>
        <div className="max-w-full mx-auto p-6 bg-black text-white rounded-lg shadow-lg">
          <h1 className="text-2xl font-bold text-center text-yellow-200 mb-4">Turn Your Mark Sheets into Mega Prizes!</h1>
          <p className="text-lg lg:text-xl text-center text-gray-200 mb-8">Mark Sheets are more than just paper on Think5Whys — they could score you & your family incredible rewards!</p>
          
          <div className="flex flex-col items-center text-center p-4 bg-black border border-blue-400 shadow-lg rounded-lg mt-4">
            <h2 className="text-lg lg:text-xl font-bold text-yellow-200 mb-4 mt-4">How to Join the Fun</h2>
            <ol className="list-decimal list-inside text-white mb-6 [&_li]:text-white">
              <li>Register at <a href="https://www.think5whys.com" className="text-indigo-500 underline">www.think5whys.com</a></li>
              <li>Applause for your, parent’s, grandparents, children, student and friends' marks</li>
              <li>Check out the "Turn Marksheets into Mega Prizes" page for details</li>
              <li>Contest Starts: November 1, 2024</li>
              <li>This contest is open for customers in India only.</li>
              <li>Terms & Conditions apply as per the Post / Add Applause Form.</li>
            </ol>
          
            <h2 className="text-xl font-semibold text-yellow-200 mb-4">Periodic Rank Updates</h2>
            <p className="text-white mb-6">Track if you ranked in the top 500 list on the leaderboard!</p>
            
            <p className="text-sm lg:text-m font-bold text-orange-500 mb-4">Important: Keep your marksheet handy to claim your prize.</p>

            <h2 className="text-lg lg:text-xl font-bold text-yello-200 mb-4">Ways to Rack Up Points</h2>
            
            <ul className="text-sm list-disc list-inside text-white mb-6 [&_li]:text-white">
              <li>100 points for signing up (All registrants will get a free one-year subscription of Digital Talking Card worth ₹300).</li>
              <li>100 points for marks {'>'} 50%</li>
              <li>100 points for each RCA record</li>
              <li>100 points for each Chronicle record</li>
              <li>100 points for each page of the Mini CAFE Digital Multimedia Book (use code THINK5WHYS to get it free).</li>
              <li>1,000 points for buying, referring, or gifting anyone from Think5Whys, Periodic Table, Children’s Collection 1, MOBook, or CAFE Digital Book.</li>
              <li>5,000 points for earning the Think5Whys or Periodic Table Champion Certification.</li>
            </ul>
            <p className="text-sm lg:text-m font-bold text-center text-yellow-200">Don’t let those marksheets collect dust—use them to win big!</p>
          </div>
        </div>
        <footer className="bg-gray-900 border-t border-blue-400 text-gray-400 py-4">
          <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
            <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
            <div className="flex flex-wrap gap-4 text-sm">
              <Link to="/about-us" className="hover:text-teal-300">About</Link>
              <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
              <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
              <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
            </div>
          </div>
        </footer>     
      </div>
  );
}

export default MyApplauseGameRules;

